"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=nursing-station.dto.js.map